import { useReduxSelector } from 'shared/hooks/useReduxSelector';
import { coworkingOperatorCompanyNameSelector } from 'shared/store/coworking/selectors/dump/coworkingOperatorCompanyNameSelector';

export function useCoworkingOperatorCompanyNameSelector(): string {
  return useReduxSelector<string>(coworkingOperatorCompanyNameSelector);
}
